module.exports = __webpack_public_path__ + "img/C103.f3cf3c9c.jpg";